import FileAttachmentPanelBase from '../../../components/FileAttachmentPanel/FileAttachmentPanel';
import type { UploadedFile } from '../../../services/MedicalIndicationController';
import {
  uploadIndicationFile,
  deleteUploadedFile,
} from '../../../services/MedicalIndicationController';

interface MedicalIndicationFileAttachmentProps {
  files: UploadedFile[];
  onFilesChange: (files: UploadedFile[]) => void;
  disabled?: boolean;
}

export default function FileAttachmentPanel({
  files,
  onFilesChange,
  disabled,
}: MedicalIndicationFileAttachmentProps) {
  return (
    <FileAttachmentPanelBase
      files={files}
      onFilesChange={onFilesChange}
      uploadFile={uploadIndicationFile}
      deleteFile={deleteUploadedFile}
      disabled={disabled}
    />
  );
}
